import React from 'react';

const SettingsNotification = (props) => {
  return <div>No content to display yet.</div>;
};

export default SettingsNotification;
